import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { Login as RaLogin, LoginForm } from 'react-admin';

const Login = () => (
  <Box
    sx={{
      display: 'flex',
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      backgroundImage: 'url(/admin-login-bg.jpg)', 
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }}
  >

    <Box
      sx={{
        flex: 7,
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: '70%',
          height: '70%',
          background: '#3d5bd2',
          borderRadius: '50%',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column', 
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
      
        <Box
          sx={{
            width: '90%',
            height: '90%',
            background: '#4365e9',
            borderRadius: '50%',
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
         
          <Box
            sx={{
              width: '80%', 
              height: '80%',
              background: '#4365e9', 
              borderRadius: '50%',
              position: 'absolute',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              opacity: 0.8, 
            }}
          />
        </Box>

  
        <Box
          component="img"
          src="/Store.png" 
          alt="Store"
          sx={{
            width: '40%',
            height: 'auto',
            objectFit: 'contain',
            position: 'absolute',
            top: '-15%', 
          }}
        />

        <Box
          component="img"
          src="/Services.png" 
          alt="Services"
          sx={{
            width: '70%',
            height: 'auto',
            objectFit: 'contain',
            position: 'relative',
            top: '-5%',
          }}
        />

     
        <Box
          sx={{
            display: 'flex',
          }}
        >
          <Box
            component="img"
            src="/Food-Delivery.png" 
            alt="Food Delivery"
            sx={{
              width: '30%',
              height: 'auto',
              objectFit: 'contain',
              position: 'absolute',
              bottom: '-15%', 
              left: '5%'
            }}
          />
          <Box
            component="img"
            src="/Moto-Taxi.png" 
            alt="Moto-Taxi"
            sx={{
              width: '30%',
              height: 'auto',
              objectFit: 'contain',
              position: 'absolute',
              bottom: '-15%',
              right: '5%'
            }}
          />
        </Box>
      </Box>
    </Box>


    <Box
      sx={{
        flex: 3,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 20px',
        overflow: 'visible', 
      }}
    >
     
      <RaLogin
        sx={{
          background: 'white',
          borderRadius: '8px',
          padding: '20px',
          width: '100%',
          maxWidth: '350px',
          border: 'none', 
          boxShadow: 'none', 
          '& .MuiPaper-root': {
              border: 'none'
          },
          '& .RaLogin-avatar': {
            display: 'none'
          }
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          mb={1}
          sx={{
            paddingLeft: '36px',
            top: '20px', 
            zIndex: 1,
            whiteSpace: 'nowrap', 
          }}
        >
          Pakyaw Kalabaw 
        </Typography>
        <Typography
          variant='h6'
          sx={{
            whiteSpace: 'nowrap',
            paddingLeft: '36px',
          }}
        >
          Admin
        </Typography>
        <LoginForm
          sx={{
            border: 'none', 
            borderRadius: '8px',
            padding: '20px',
            '& .MuiTextField-root': {
              marginBottom: 2,
              '& .MuiInputBase-root': {
                borderRadius: '4px',
                backgroundColor: '#f5f5f5',
                border: 'none',
                outline: 'none',
              },
              '& .MuiInputAdornment-root': {
                display: 'none',
              },
            },
            '& .RaLoginForm-actions': {
              display: 'flex',
              justifyContent: 'center', 
              marginTop: '20px', 
            },
            '& .RaLoginForm-actions button': {
              backgroundColor: '#6B48FF',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              textTransform: 'uppercase',
              width: '100%', 
              '&:hover': {
                backgroundColor: '#5A3EDB',
              },
            },
            '& .MuiButtonBase-root': {
              width: '50%',
              left: '50%'
            }
          }}
        />
      </RaLogin>
    </Box>
  </Box>
);

export default Login;